<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    :disabled="disabledPull || visible"
    @refresh="onRefresh"
  >
    <div class="page" style="padding-top:0;">
      <!-- 头图 -->
      <!-- <div
        class="page_header bg_contain"
        :style="{
          backgroundImage: `url(${activityInfo.icon})`,
        }"
      >
      </div> -->
      <div class="main" style="min-height:100vh">
        <div :key="gameInfo.gameId"  class="main_game flex_center border_bottom_1px mb_8">
          <div class="game_icon mr_6 bg_contain" :style="{ backgroundImage: `url(${gameInfo.gameIcon})` }"></div>
          <div class="game_main flex_1">
            <div class="game_top mb_2 flex_between">
              <div class="game_info">
                <div class="game_title mb_6 fs_15 color_black van-ellipsis">{{ gameInfo.gameName }}</div>
                <div class="game_desc d_flex">
                  <div class="game_score color_grey pr_6 mr_6">{{ gameInfo.score }}分</div>
                  <div class="game_version color_grey pr_6 mr_6">{{ gameInfo.version }}版本</div>
                  <div v-if="gameInfo.depict" class="game_depict color_grey pr_6 mr_6">{{ gameInfo.depict }}</div>
                </div>
              </div>
              <div class="game_btn" @click.stop="onGoDownload">
                查看/下载
              </div>
            </div>
            <GameTag :tags="gameInfo.tags" />
          </div>
        </div>
        <!-- 备注活动点 -->
        <!-- <div class="block">
          <div class="block_main">
            <div class="block_title white_blank bg_contain" :style="{ backgroundImage: `url(${CDN_URL}/block_title.png)` }">
              <img :src="`${CDN_URL}/title_wel.png`" alt="">
              <div class="block_title_enter"></div>
              <div class="block_title_main color_black flex_center mt_28">
                <div class="block_main_icon w_25 h_25 bg_contain" :style="{ backgroundImage: `url(${CDN_URL}/active_icon.png)` }"></div>
                <div class="block_main_text ml_12 mr_8 fs_20 bold">当前累计活跃点:</div>
                <div class="block_main_value fs_20 bold" style="color: #ff1e1e">{{ point }}</div>
              </div>
              <div class="block_main_detail fs_12 text_underline" @click="onShowRewardRecord">活跃点明细</div>
            </div>
            <div class="block_gifts">
              <div
                class="block_gift block_item flex_center"
                v-for="gf in rewardList"
                :key="gf.id"
              >
                <div class="gift_icon w_60 h_60 round_5 mr_10 bg_contain" :style="{backgroundImage: `url(${gf.icon})`}"></div>
                <div class="gift_info flex_1 w_0">
                  <div class="gift_title fs_15 bold color_black mb_6">{{ gf.giftName }}</div>
                  <div class="gift_desc fs_10" style="color: #9F5829; line-height: 1.24;">{{ gf.giftContent }}</div>
                </div>
                <div class="gift_right flex_center flex_col">
                  <div class="gift_btn" :class="{ filter_grayscale: gf.received }" @click="onReceived(gf, 1)">{{ gf.received ? '已领取' : '领取' }}</div>
                  <div class="gift_condi fs_10 mt_10" style="color: #de482b">累计{{ gf.activeNum }}活跃点解锁</div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="block mt_8">
          <!-- <div class="block_title">
            <img :src="`${CDN_URL}/title_rece.png`" alt="">
          </div> -->
          <div class="block_main">
            <div class="block_gifts">
              <div class="block_task"   v-for="tk in taskList" :key="tk.id" >
                <!-- <span style="font-size:12px;margin-bottom:4px;display:inline-block;" v-show="newUserTask.includes(tk.conditionType)">新用户专属</span> -->
                <div class="isPlay bg_contain" v-show="newUserTask.includes(tk.conditionType)">
                  新用户专属
                </div>
                <div class="block_gift block_item flex_center"  @click="onExpand(tk)">
                  <div class="gift_icon w_60 h_60 round_5 mr_10 bg_contain" :style="{backgroundImage: `url(https://image.hzwxbz2.cn/btbox/2024/pic/jyy_1726228444603_2c39627d5f8fcc237278eecc3731c3d7.png)`}"  ></div>
                  <div class="gift_info flex_1 w_0">
                    <div class="gift_title fs_15 bold color_black mb_6">{{ tk.rewardList[0] && tk.rewardList[0].name }}</div>
                    <div class=" f_ai_center">
                      <div class="gift_desc mr_10 fs_10" style="color: #9F5829; line-height: 1.24;width:100%;margin-bottom:4px;">获取方式: {{ getConditionName(tk, 1) }}</div>
                      <div class="gift_desc mr_10 fs_10" style="color: #9F5829; line-height: 1.24;width:100%;margin-bottom:4px;">奖励内容: {{ tk.rewardList[0] && tk.rewardList[0].giftContent }}</div>
                      <!-- <div class="gift_expand bg_contain "  :class="{ transform_180deg: expandIds.includes(tk.id) }"><i class="fs_15 iconfont yw-jiantou9" style="color: #9F5829"></i></div> -->
                    </div>
                  </div>
                  <div class="gift_right flex_center flex_col">
                    <div class="gift_btn"  :class="{ filter_grayscale: tk.receiveType === 3 || ([1, 2, 3].includes(tk.conditionType) && historyRole) }"  @click.stop="onReceived(tk, 2)"  >
                      {{ getBtnText(tk) }}
                    </div>
                    <div class="gift_condi fs_10 mt_10" style="color: #de482b">
                      {{ getConditionName(tk, 2) }}
                    </div>
                  </div>
                </div>
                <!-- <div
                  class="block_extra"
                  :class="{ h_0: !expandIds.includes(tk.id), padding_0: !expandIds.includes(tk.id) }"
                  :style="{ height: (16 + tk.rewardList.length * 60 + (tk.rewardList.length - 1) * 6) + 'px' }"
                >
                  <div
                    class="block_wel flex_center"
                    v-for="w in tk.rewardList"
                    :key="w.name"
                  >
                    <div
                      class="block_wel_icon w_44 h_44 round_5 mr_10 bg_contain"
                      :style="{backgroundImage: `url(${w.icon})`}"
                    ></div>
                    <div class="block_wel_info flex_1 w_0">
                      <div class="block_wel_name bold color_black fs_13 mb_8">{{ w.name }}</div>
                      <div class="block_wel_desc fs_10" style="color: #FF7559">{{ w.type === 2 ? `活跃点数+${w.value}` : `${w.giftContent}` }}</div>
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ActivityPopup
      :visible.sync="visible"
      v-bind="feedback"
      :progressAttrs="progressAttrs"
      :headerStyle="{background: '#FFB017'}"
      :innerTitleStyle="{color: '#FFB017'}"
      confirmButtonColor="#FFB017"
      @confirm="feedback.onSure"
    >
      <template v-if="feedbackType === FEEDTYPE_MAP.CONDITION_NOT_SATISFY">
        <template v-if="errCode === 90709">
          <p class="text_center fs_18 mb_8">活动期间内创角</p>
          <p class="text_center fs_18 mb_16">
            且角色等级达 <span style="color: #c73534">{{ curWel.conditionValue }}</span> 级可领
          </p>
        </template>
        <template v-if="errCode === 90711">
          <p class="text_center fs_18 mb_8">当日游戏内充值金额</p>
          <p class="text_center fs_18 mb_16">
            达到 <span style="color: #c73534">{{ curWel.conditionValue }}</span> 元即可领取奖励
          </p>
        </template>
        <template v-if="errCode === 90712">
          <p class="text_center fs_18 mb_8">活动期间游戏内充值金额</p>
          <p class="text_center fs_18 mb_16">
            达到 <span style="color: #c73534">{{ curWel.conditionValue }}</span> 元即可领取奖励
          </p>
        </template>
        <template v-if="errCode === 90713">
          <p class="text_center fs_16 mb_6">活动期间内创角且连续{{ curWel.x }}天付费大于{{curWel.y}}元，即可领取奖励</p>
        </template>
      </template>
    </ActivityPopup>
    <Record
      ref="recordRef"
      :activityId="actId"
      :placeId="placeId"
      @close="setDisabledPull"
    />
  </PullRefresh>
</template>

<script>
import {
  setPageTitle, setRightTxt, clickRightTxt, toLogin,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import ActivityPopup from "@/subtree/h5/comps/Popup";
import EventTrack from '@/mixins/eventTrack'
import LinkTo from '@/mixins/linkTo'
import { getActivePlaceDetailApi, exchangeActiveApi } from '@/apis/btBoxActivity'
import { FEEDTYPE_MAP, ActivityInfo, ConditionTypeEnum, FrequenceEnum } from './config'
import GameTag from '@/views/box/rebate2voucher/gameTag.vue'
import { CDN_URL } from './config'
import AvoidFirstActivate from '@/mixins/avoidFirstActivate'
import Record from './record'

const { SUCCESS, INSUFFICIENT_GIFT, NO_ROLE, FIRST_CHARGE,CONDITION_NOT_SATISFY,} = FEEDTYPE_MAP

export default {
  components: {
    PullRefresh,
    ActivityPopup,
    GameTag,
    Record,
  },
  mixins: [EventTrack, LinkTo, AvoidFirstActivate],
  data () {
    return {
      newUserTask:[1,3,6,2,], //【创角】【首次充值】【连续付费】【角色等级】这几个是新手任务  1 3 6 2
      disabledPull: false,
      ConditionTypeEnum,
      activityInfo: new ActivityInfo(),
      isLoading: false,
      visible: false,
      FEEDTYPE_MAP,
      feedbackType: SUCCESS,
      progressAttrs: {
        currentVal: 0,
        targetVal: 100,
        skins: {
          color: '#c73534',
          background: 'linear-gradient(90deg, #fe766b 0%, #fdb46b 100%)',
          borderColor: '#c73534',
        },
      },
      point: 0,
      gameInfo: {},
      historyRole: false,
      rewardList: [],
      taskList: [],
      expandIds: [],
      receivedLoading: [],
      skipInit: true,
      curWel: {},
      notSatisfyMessages: [], // 不满足条件的文案
      errCode: '',
      CDN_URL,
    }
  },
  activated () {
    this.triggerVisible(false)
    if (this.activityInfo.title) {
      setRightTxt('活动规则');
    }
  },
  computed: {
    actId () {
      return this.$route.query.id || 2
    },
    placeId () {
      return this.$route.query.placeId
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      const {
        rewardList = [], giftContent, giftId, giftName,
        activeNum, conditionType
      } = this.curWel
      const hasGift = rewardList.some(v => v.type === 1) || giftContent
      const reward_list = this.getTrackRewardList(rewardList)
      const isTask = !!this.curWel.receiveType
      return {
        [SUCCESS]: {
          title: '恭喜您获得',
          innerTitle: giftName || rewardList.map(v => v.name).join('、'),
          message: hasGift ? [
            '礼包码已存放在',
            '【我的】-【我的礼包】-【活动礼包】'
          ] : [],
          confirmButtonText: hasGift ? '查看礼包' : '去兑换礼包',
          onSure: () => {
            if (isTask) {
              this.eventTrack({
                event: "register_active_detail_t_r_button",
                event_field: this.getTrackInfo({
                  reward_list,
                  task_type: conditionType,
                  scene_type: hasGift ? 1 : 3,
                }),
              })
            } else {
              this.eventTrack({
                event: "register_active_detail_r_popup_button",
                event_field: this.getTrackInfo({
                  point: this.point, gift_id: giftId,
                  gift_name: giftName, condition_value: activeNum,
                  scene_type: 1
                }),
              })
            }
            this.triggerVisible(false)
            if (hasGift) this.handleGoGift()
          }
        },
        [INSUFFICIENT_GIFT]: {
          title: '提示',
          message: [
            '兑换码生成错误，请联系客服'
          ],
          confirmButtonText: '联系客服',
          onSure: () => {
            if (isTask) {
              this.eventTrack({
                event: "register_active_detail_t_r_button",
                event_field: this.getTrackInfo({
                  reward_list,
                  task_type: conditionType,
                  scene_type: 2,
                }),
              })
            } else {
              this.eventTrack({
                event: "register_active_detail_r_popup_button",
                event_field: this.getTrackInfo({
                  point: this.point, gift_id: giftId,
                  gift_name: giftName, condition_value: activeNum,
                  scene_type: 2
                }),
              })
            }
            this.triggerVisible(false)
            this.onRelationServer()
          },
        },
        [NO_ROLE]: {
          title: '任务提示',
          message: [
            '在活动时间内下载游戏',
            '并用此账号创角即可领取奖励',
          ],
          confirmButtonText: '去完成',
          onSure: () => {
            this.eventTrack({
              event: "register_active_detail_t_p_button",
              event_field: this.getTrackInfo({
                reward_list,
                task_type: conditionType,
                current_value: this.progressAttrs.currentVal || this.point,
                target_value: this.progressAttrs.targetVal,
              }),
            })
            this.triggerVisible(false)
            this.goDownload()
          }
        },
        [CONDITION_NOT_SATISFY]: {
          title: '任务提示',
          confirmButtonText: '去完成',
          message: this.notSatisfyMessages,
          showProgress: true,
          onSure: () => {
            this.eventTrack({
              event: "register_active_detail_t_p_button",
              event_field: this.getTrackInfo({
                reward_list,
                task_type: conditionType,
                current_value: this.progressAttrs.currentVal || this.point,
                target_value: this.progressAttrs.targetVal,
              }),
            })
            this.triggerVisible(false)
            this.goDownload()
          }
        },
        [FIRST_CHARGE]: {
          title: '任务提示',
          confirmButtonText: '去完成',
          message: [
            '在活动时间创角并完成首次充值',
            '即可领取奖励'
          ],
          onSure: () => {
            this.eventTrack({
              event: "register_active_detail_t_p_button",
              event_field: this.getTrackInfo({
                reward_list,
                task_type: conditionType,
                current_value: this.progressAttrs.currentVal || this.point,
                target_value: this.progressAttrs.targetVal,
              }),
            })
            this.triggerVisible(false)
            this.goDownload()
          }
        },
      }
    },
  },
  methods: {
    init () {
      return this.getActInfo().then(res => {
        this.eventTrack({
          event: "register_active_detail",
          event_field: this.getTrackInfo(),
        })
        setPageTitle(this.activityInfo.title)
        this.setHeaderContent()
      })
    },
    getActivityInfo () {
      this.init()
    },
    onRefresh () {
      this.init().finally(res => {
        setTimeout(() => {
          this.isLoading = false
        }, 100)
      })
    },
    getActInfo () {
      return getActivePlaceDetailApi({
        activityId: this.actId,
        placeId: this.placeId,
      }).then(res => {
        const { gameInfo, activityInfo, historyRole, point, rewardList, taskList } = res.data || {}
        this.activityInfo = activityInfo || new ActivityInfo()
        this.point = point
        this.rewardList = rewardList || []
        this.taskList = taskList || []
        this.gameInfo = gameInfo || {}
        this.historyRole = historyRole
        setPageTitle(this.activityInfo.title)
      }).catch(err => {
        if (err.response && err.response.data.code === 401) {
          toLogin("/loginKey/LoginByKeyPhoneActivity")
        }
        const { code, msg } = err
        const errorCodes = [90601, 90702]
        if (errorCodes.includes(code)) {
          this.$toast(msg)
          this.$router.back()
        }
      })
    },
    onReceived (tk, type) {
      const { id, receiveType, received, conditionValue,conditionValueV2, giftId,  giftName, activeNum, rewardList, conditionType,x } = tk || {}
      // 活跃点领取
      if (type === 2) {
        if (([1, 2, 3].includes(conditionType) && this.historyRole) || receiveType === 3) return
      }
      // 活跃任务
      if (type === 1 && received) return
      const f = type + '-'  + id
      if (this.receivedLoading.includes(f)) return
      this.receivedLoading.push(f)
      this.curWel = tk
      const reward_list = this.getTrackRewardList(rewardList)
      if (type === 1) {
        this.eventTrack({
          event: "register_active_detail_r_draw",
          event_field: this.getTrackInfo({
            point: this.point, gift_id: giftId,
            gift_name: giftName, condition_value: activeNum,
          }),
        })
      } else {
        this.eventTrack({
          event: "register_active_detail_t_draw",
          event_field: this.getTrackInfo({
            reward_list,
            task_type: conditionType,
            scene_type: receiveType,
          }),
        })
      }
      exchangeActiveApi({
        placeId: this.placeId,
        activityId: this.actId,
        id,
        propType: type
      }).then(res => {
        const cdk = res.data
        
        if (cdk) {
          this.triggerVisible(true, SUCCESS)
        } else {
          this.triggerVisible(true, INSUFFICIENT_GIFT)
        }
        if (type === 1) {
          this.eventTrack({
            event: "register_active_detail_r_popup",
            event_field: this.getTrackInfo({
              point: this.point, gift_id: giftId,
              gift_name: giftName, condition_value: activeNum,
              scene_type: cdk ? 1 : 2
            }),
          })
        }
        if (type === 2) {
          this.eventTrack({
            event: "register_active_detail_t_result",
            event_field: this.getTrackInfo({
              reward_list,
              task_type: conditionType,
              scene_type: cdk ? 1 : 2
            }),
          })
        }
        this.getActInfo()
      }).catch((err) => {
        const { code, msg } = err
        const reportErrorData = () => {
          this.eventTrack({
            event: "register_active_detail_t_popup",
            event_field: this.getTrackInfo({
              reward_list,
              task_type: conditionType,
              current_value: msg * 1 || this.point,
              target_value: conditionValue || x * 1, // 如果是连续付费肯定是x
            }),
          })
        }
        // 需要额外处理的错误码
        const handleCodes = [1001, 90708, 90709, 90710, 90711, 90712,90713]
        if (handleCodes.includes(code)) {
          if (code === 1001) {
            this.getActInfo()
            this.triggerVisible(true, INSUFFICIENT_GIFT)
            if (type === 1) {
              this.eventTrack({
                event: "register_active_detail_r_popup",
                event_field: this.getTrackInfo({
                  point: this.point, gift_id: giftId,
                  gift_name: giftName, condition_value: activeNum,
                  scene_type: 2
                }),
              })
            }
            if (type === 2) {
              this.eventTrack({
                event: "register_active_detail_t_result",
                event_field: this.getTrackInfo({
                  reward_list,
                  task_type: conditionType,
                  scene_type: 2
                }),
              })
            }
          }
          if (code === 90708) {
            this.triggerVisible(true, NO_ROLE)
            reportErrorData()
          }
          if (code === 90710) {
            this.triggerVisible(true, FIRST_CHARGE)
            reportErrorData()
          }
          // 90709 任务条件不满足-等级不足 现有等级在msg中
          // 90710 任务条件不满足-首次支付不满足
          // 90711 任务条件不满足-每日支付不满足 现有充值在msg中
          // 90712 任务条件不满足-累计支付不满足 总充值在msg中
          if ([90709, 90711, 90712].includes(code)) {
            this.progressAttrs.currentVal = msg * 1
            this.progressAttrs.targetVal = conditionValue * 1
            this.errCode = code
            this.triggerVisible(true, CONDITION_NOT_SATISFY)
            reportErrorData()
          }
          if ([90713].includes(code)) {
            const xy = JSON.parse(conditionValueV2)
            this.progressAttrs.currentVal =  msg * 1
            this.progressAttrs.targetVal = xy.x * 1
            this.errCode = code
            this.curWel.x = xy.x * 1
            this.curWel.y = xy.y * 1
            console.log(this.progressAttrs.targetVal,'targetVal')
            // 连续付费是conditionValueV2
            this.triggerVisible(true, CONDITION_NOT_SATISFY)
            reportErrorData()
          }
          return
        }
        // 需要刷新接口的错误码
        const flashCodes = [90703, 90704, 90706, 90707]
        if (flashCodes.includes(code)) {
          this.getActInfo()
        }
        this.$toast(msg)
      }).finally(() => {
        this.receivedLoading = this.receivedLoading.filter(i => i !== f)
      })
    },
    triggerVisible (visible, type) {
      if (visible && this.visible) return
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = visible
    },
    getConditionName (tk = {}, type = 1) {
      const { conditionValue, conditionType, frequency } = tk
      if (type === 1) {
        const conditionValueV2 = tk.conditionValueV2 ? JSON.parse(tk.conditionValueV2) : {}
        const map = {
          1: '活动期间游戏创角',
          2: `活动期间创角且角色等级达${conditionValue}级`,
          3: `活动期间创角且首次充值`,
          4: `活动期间当日付费满${conditionValue}元`,
          5: `活动期间累计付费满${conditionValue}元`,
          6: `活动期间连续${conditionValueV2.x}日累充大于${conditionValueV2.y}`
        }
        return map[conditionType]
      }
      if (type === 2) {
        return FrequenceEnum.find(i => i.value === frequency)?.label || ''
      }
    },
    getBtnText (tk = {}) {
      const { receiveType, conditionType } = tk
      const map = { 1: '去完成', 2: '领取', 3: '已领取' }
      return ([1, 2, 3].includes(conditionType) && this.historyRole) ? '历史创角' : map[receiveType]
    },
    onExpand (tk) {
      const { id, conditionType, rewardList } = tk || {}
      if (!this.expandIds.includes(id)) {
        this.expandIds.push(id)
      } else {
        this.expandIds = this.expandIds.filter(i => i !== id)
      }
      this.eventTrack({
        event: "register_active_detail_task",
        event_field: this.getTrackInfo({
          task_type: conditionType,
          reward_list: this.getTrackRewardList(rewardList)
        }),
      })
    },
    getTrackRewardList (list = []) {
      return Array.isArray(list) ? list.map(v => ({ value: v.value, type: v.type, name: v.name })) : []
    },
    onGoDownload () {
      this.eventTrack({
        event: "register_active_detail_look",
        event_field: this.getTrackInfo(),
      })
      this.goDownload()
    },
    goDownload () {
      // 36 -> h5活动
      this.handleGoDownload(this.gameInfo.gameId, 36)
    },
    onShowRewardRecord () {
      this.eventTrack({
        event: "register_active_detail_record_button",
        event_field: this.getTrackInfo({ point: this.point }),
      })
      this.$refs.recordRef.triggerVisible(true)
      this.setDisabledPull(true)
      this.eventTrack({
        event: "register_active_detail_record_show",
        event_field: this.getTrackInfo({ point: this.point }),
      })
    },
    setDisabledPull (f = false) {
      this.disabledPull = f
    },
    // 设置顶部内容
    setHeaderContent() {
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.eventTrack({
          event: "register_active_rule",
          event_field: this.getTrackInfo({}, false),
        })
        this.handleGoRulePage(18)
      });
    },
    getTrackInfo (params = {}, needGame = true) {
      const gameInfo = needGame ? { game_id: this.gameInfo.gameId, game_name: this.gameInfo.gameName } : {}
      return JSON.stringify({
        activity_id: this.actId,
        title: this.activityInfo.title,
        ...gameInfo,
        ...params,
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import "./index.scss";
.isPlay {
  position: absolute;
  top: -8px;
  left: 12px;
  background-image: url("//static.hzwxbz3.cn/Lianyun/font_end/wxhd/box_payAmount/tips.png");
  height: 24px;
  line-height: 18px;
  font-size: 10px;
  color: #fefefe;
  width: 68px;
  text-align: center;
  z-index: 1;
}
.main_game {
  background-color: #fff;
  padding: 12px 12px 8px 12px;
  border-radius: 6px;
  p {
    text-align: center;
    color: #9C9C9C;
    font-size: 13px;
    line-height: 18px;
  }
  .game_icon {
    width: 60px;
    height: 60px;
    border-radius: 6px;
  }
  .game_title {
    white-space: nowrap;
  }
  .game_main {
    .game_score {
      font-size: 10px;
    }
    .game_desc {
      font-size: 10px;
    }
    .game_score, .game_version {
      border-right: 1px solid #b6b6b6;
    }
    .game_info {
      flex: 1;
      width: 0;
    }
  }
  .game_btn {
    padding: 10px 12px;
    font-size: 12px;
    border-radius: 100px;
    color: #fff;
    background-color: #18BD30;
  }
}
.white_blank {
  width: 100%;
  height: 120px;
}
.block_gift {
  background-color: #fff;
  padding: 10px 10px 6px 18px;
  border-radius: 6px;
}
.block_item {

}
.block_item + .block_item {
  margin-top: 8px;
}
.gift_btn {
  font-size: 11px;
  width: 60px;
  text-align: center;
  background: #f8c233;
  border-radius: 100px;
  padding: 7px 0;
}
.block_task + .block_task {
  margin-top: 6px;
}
.block_task {
  position: relative;
  .block_gift {
    padding-left: 12px;
  }
}
.block_extra {
  width: calc(100% - 12px);
  margin-left: 6px;
  padding: 8px 16px;
  background-color: #DEECEA;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  overflow: hidden;
  transition: all 0.3s ease;
  .block_wel {
    background-color: #fff;
    padding: 8px 24px;
    border-radius: 8px;
  }
  .block_wel + .block_wel {
    margin-top: 6px;
  }
}
.gift_expand {
  transition: transform 0.3s ease;
}
.transform_180deg {
  transform: rotate(180deg);
}
.padding_0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}
.h_0 {
  height: 0 !important;
}
.msg_main_color {
  color: #C73534;
}
.block_title {
  position: relative;
  .block_main_detail {
    position: absolute;
    top: 2px;
    right: 6px;
  }
}
</style>
<style lang="scss">
.popup_title {
  font-weight: bold;
}
</style>